import { messages as utilMessages } from '@sdir/utilities/lib/localization';
import { generalMessages } from '@sdir/blueprint.aps/lib/components';

/* eslint-disable max-len */
export default {
  no: {
    ...utilMessages.no,
    ...generalMessages.no,
    'app.title': 'Min Side Påtegning',
    'userbar.sdirlink': 'Gå til Sjøfartsdirektoratet (sdir.no)',
    'userbar.menu': 'Meny',
    'userbar.skiplink': 'Hopp til hovedinnhold',
    'footer.tagline': '- Den foretrukne maritime administrasjonen',
    'footer.about.title': 'Om sdir.no',
    'footer.about.privacy': 'Personvernerklæring',
    'footer.about.accessibility': 'Tilgjengelighetserklæring',
    'footer.social.title': 'Følg oss',
    'footer.social.facebook': 'Besøk oss på Facebook',
    'footer.social.instagram': 'Besøk oss på Instagram',
    'footer.social.linkedin': 'Besøk oss på LinkedIn',
    'general.back': 'Tilbake',
    'general.cancel': 'Avbryt',
    'general.yes': 'Ja',
    'general.add': 'Legg til',
    'general.submit': 'Send inn',
    'general.backtoapplications': 'Tilbake til søknader',
    'general.next': 'Neste',
    'general.upload': 'Last opp',
    'general.remove': 'Remove',
    'general.delete': 'Slette',
    'general.downloadpdf': 'Last ned som PDF',
    'general.clearfilter': 'Tøm filteret',
    'general.form.error': 'Obligatorisk felt',
    'general.form.name': 'Navn',
    'general.form.gender': 'Kjønn',
    'general.form.firstname': 'Fornavn',
    'general.form.lastname': 'Etternavn',
    'general.form.dateOfBirth': 'Fødselsdato',
    'general.form.email': 'Epost',
    'general.form.error.dNumber': 'D-nummer kan kun inneholde tall.',
    'general.form.error.datemustbefuture': 'Vennligst velg en dato senere enn i dag',
    'general.form.error.emptyfile': 'Filen er tom. Vennligst last opp en gyldig fil.',
    'general.form.error.mandatorylastname': 'Både fornavn og etternavn er påkrevd.',
    'general.form.error.email': 'Ikke et gyldig e-postformat.',
    'dashboard.title': 'Pågående søknader',
    'dashboard.ingress':
      'På denne siden kan du søke om påtegning for sjøfolk og se status på dine pågående søknader.',
    'code.title': 'Register by code',
    'code.ingress':
      'If you have been invited to apply for endorsements and got a one time code, you should enter it here.',
    'usermanagement.title': 'User management',
    'usermanagement.table.note': 'Intern kommentar',
    'usermanagement.table.status': 'Invitation status',
    'usermanagement.table.status.Accepted': 'Accepted',
    'usermanagement.table.status.Active': 'Awaiting',
    'usermanagement.table.status.Expired': 'Expired',
    'usermanagement.button.add': 'Add firm',
    'usermanagement.button.renew': 'Renew',
    'usermanagement.empty.title': 'No firms yet',
    'usermanagement.empty.description':
      'You have not invited any firms yet. To get started, add a new firm by clicking the button below.',
    'application.filter.status.New': 'New applications',
    'application.filter.status.Approved': 'Utstedt',
    'application.filter.status.Rejected': 'Avslått',
    'application.filter.status.ReadyForPayment': 'Klar til betaling',
    'application.filter.status.Processing': 'Processing',
    'application.filter.status.AwaitingClarification': 'Awaiting clarification',
    'application.noaccess.title': 'Ingen tilgang ennå',
    'application.noaccess.description':
      'Du representerer ikke noe rederiselskap ennå. For å komme i gang trenger du en aktiveringskode. Klikk på knappen for å skrive inn koden og få tilgang.',
    'application.empty.title': 'No applications yet',
    'application.empty.description':
      'You have not created an application yet. To get started, create a new application by clicking the button below.',
    'application.cra.heading': 'CRA',
    'application.dispensation.heading': 'Dispensation',
    'application.confirmdelete.title': 'Slette søknad',
    'application.confirmdelete.description': 'Er du sikker på at du vil slette søknad?',
    'application.rejection.link': 'Begrunnelse',
    'application.rejection.title': 'Begrunnelse for avslag',
    'application.receipt.link': 'Kvittering',
    'application.endorsement.minrequirements':
      'This certificate is issued in accordance with the International Convention on Standards of Training, Certification, and Watchkeeping for Seafarers, 1978, as amended.',
    'application.endorsement.limitation': 'I samsvar med nasjonal sertifisering',
    'application.new.title': 'Søknad om påtegning',
    'application.new.ingress':
      'For å søke om påtegning på vegne av en sjømann, fyll ut skjemaet og legg ved nødvendig dokumentasjon. Vi krever sjømannens personlige e-postadresse for å sende innloggingsdetaljer for å få tilgang til og dele sertifikatene deres.',
    'application.code.button': 'Skriv inn kode',
    'application.new.button': 'Ny søknad',
    'application.steps.applicant': 'Søker',
    'application.steps.sailor': 'Sjømannen',
    'application.steps.certificate': 'Nasjonalt sertifikat',
    'application.steps.requirements': 'Krav',
    'application.steps.cra': 'CRA',
    'application.steps.summary': 'Oppsummering',
    'application.steps.payment': 'Betaling',
    'application.steps.payment.submit': 'Betale søknaden',
    'application.table.header.createdAt': 'Opprettet',
    'application.table.header.name': 'Sjømannens navn',
    'application.table.header.status': 'Status',
    'application.table.header.payment': 'Betaling',
    'application.table.header.nationality': 'Nasjonalitet',
    'application.table.header.contactEmail': 'Søker',
    'application.table.header.endorsement': 'Påtegning',
    'application.table.header.onBehalfOf': 'På vegne av',
    'application.table.count': 'Antall',
    'application.table.showdetails': 'View application details',
    'application.table.hidedetails': 'Hide application details',
    'application.applicant.title': 'Din informasjon',
    'application.applicant.onbehalf': 'På vegne av',
    'application.applicant.email': 'E-post organisasjon',
    'application.sailor.title': 'Opplysninger om sjømannen',
    'application.sailor.description':
      'Du kan finne sjømannen ved hjelp av tidligere påtegninger. Legg inn informasjonen manuelt hvis sjømannen er ny hos Sjøfartsdirektoratet.',
    'application.sailor.previouslyregistered':
      'Har sjømannen sertifikat utstedt av Sjøfartsdirektoratet?',
    'application.sailor.yes': 'Ja, skriv inn sertifikatnummer',
    'application.sailor.no': 'Nei, registrer sjømannen manuelt',
    'application.sailor.name': 'Sjømannens navn',
    'application.sailor.photo': 'Sjømannens foto',
    'application.sailor.citizenship': 'Statsborgerskap',
    'application.sailor.dNumber': 'Norwegian d number (optional)',
    'application.sailor.email': 'Personlig/privat epost',
    'application.sailor.emailinfo':
      'Vi krever sjømannens personlige e-postadresse (ikke firmaets e-postadresse). Påloggingsdetaljer vil bli sendt til sjømannen slik at de kan få tilgang til sine påtegninger.',
    'application.certificate.title': 'Sjømanns nasjonalt sertifikat',
    'application.certificate.requestedCertificate': 'Requested certificate',
    'application.certificate.certificate': 'Nasjonalt sertifikat',
    'application.certificate.certificateNumber': 'Sertifikatnummer',
    'application.certificate.expiryDate': 'Utløpsdato',
    'application.certificate.issuedBy': 'Utstedet av',
    'application.certificate.nationalcertificate': 'Copy of national certificate',
    'application.certificate.add': 'Legg til sertifikat',
    'application.certificate.remove': 'Fjerne sertifikat',
    'application.certificate.radioinfo':
      'Applications for GOC/ROC and other endorsements must be submitted as separate applications.',
    'application.requirements.title': 'Requirements for issuance of the selected endorsement',
    'application.requirements.declaration.title': 'Declaration of competence',
    'application.requirements.declaration.description':
      'The applicant has the necessary knowledge of Norwegian maritime legislation and has satisfactory command of the English language,  as required by regulation  I/10 of the STCW Convention, cf. Regulations of 22 December 2011 No. 1523 section 85  subparagraph (1) (b).',
    'application.requirements.declaration.checkbox':
      'Jeg erklærer herved overholdelse av gjeldende kompetansekrav.',
    'application.requirements.grossTonnage.title': 'Dispensasjon for Master – Gross Tonnage',
    'application.requirements.grossTonnage.description': ' ',
    'application.requirements.grossTonnage.option1':
      'To be used exclusively for vessels below 250 BT (small vessels)',
    'application.requirements.grossTonnage.option2':
      'The vessel has a gross tonnage of more than 250BT',
    'application.requirements.dispensation.title': 'Dispensation',
    'application.requirements.dispensation.description':
      'An endorsement issued to seafarers who are not EEA citizens does not entitle the holder to serve as master on ships of 250 gross tonnage or more. However, the Norwegian Maritime Authority may permit such service on ships which are registered in the Norwegian International Ship Register. The Norwegian Maritime Authority may take emergency preparedness into consideration when assessing whether permission shall be given, in accordance with Section 87 (3) of the Regulations of 22 December 2011 No. 1523 on qualifications and certificates for seafarers.',
    'application.requirements.dispensation.checkbox':
      'Jeg bekrefter at jeg ønsker å søke om denne tillatelsen i samsvar med betingelsene nevnt ovenfor',
    'application.requirements.course.title': 'Course',
    'application.requirements.course.description':
      'To serve as a master on board a Norwegian ship, completion of the Course in Norwegian Maritime Legislation (NIS course) at an approved course center is mandatory.',
    'application.requirements.error.dispensation':
      'When vessel tonnage is more than 250, you need dispensation.',
    'application.requirements.error.nationality':
      'Your nationality prevents you from getting dispensation.',
    'application.cra.title': 'Confirmed receipt of application (CRA)',
    'application.cra.description':
      'Below is an indication of whether a temporary Certificate of Recognition (CRA) can be issued automatically.',
    'application.cra.automatic': 'Ønskes CRA utstedt automatisk?',
    'application.summary.title': 'Summary',
    'application.summary.crainfo.title': 'Important Information Regarding CRA Issuance:',
    'application.summary.crainfo.part1':
      'The Certificate of Receipt of Application (CRA) will only be issued once the payment has been registered by the Norwegian Maritime Authority.',
    'application.summary.crainfo.part2':
      'If you need the <b>CRA urgently</b>, we strongly recommend paying by credit card. Payment by invoice and bank transfer to the organisation takes up to one week before it is registered and the CRA can be issued.',
    'application.summary.crainfo.part3':
      'Once the payment is registered, the CRA will be available for download from your application page.',
    'application.address.title': 'Send til adresse',
    'application.address.company': 'Bedrift',
    'application.address.contactEmail': 'Epost',
    'application.address.address': 'Address',
    'application.address.address2': 'Address 2',
    'application.address.zip': 'Postnummer',
    'application.address.city': 'Poststed',
    'application.address.country': 'Land',
    'application.payment.title': 'Betaling',
    'application.payment.nocharges': 'Kunne ikke finne noen gebyr',
    'application.payment.alreadypaid.title': 'Betaling er allerede utført',
    'application.payment.alreadypaid.description': 'Søknaden venter nå på behandling.',
    'application.payment.couldnotstart': 'Kunne ikke starte betalingsprosessen, prøv igjen senere.',
    'application.payment.complete': 'Gå videre til oppsummering',
    'application.payment.failed': 'Kunne ikke fullføre betaling',
    'application.clarify.title': 'Venter på avklaring',
    'application.clarify.comment': 'Kommentar',
    'application.clarify.niscourse': 'NIS-kurs',
    'application.clarify.nationalcertificate': 'Nasjonalt sertifikat',
    'application.clarify.upload.niscourse': 'Laste opp NIS-kurs',
    'application.clarify.upload.niscourse.desc': 'Laste opp dokumentasjon for NIS-kurs',
    'application.clarify.upload.nationalcertificate': 'Laste opp nasjonalt sertifikat',
    'application.clarify.upload.nationalcertificate.desc': 'Laste opp dokumentasjon for ',
    'imagecropper.cancel': 'Avbryt',
    'imagecropper.upload': 'Last opp nytt bilde',
    'imagecropper.Photo': 'Foto',
    'imagecropper.zoom': 'Zoom',
    'imagecropper.rotation': 'Rotering',
  },
  en: {
    ...utilMessages.en,
    ...generalMessages.en,
    'app.title': 'Endorsement',
    'userbar.sdirlink': 'Go to Sjøfartsdirektoratet (sdir.no)',
    'userbar.menu': 'Menu',
    'userbar.skiplink': 'Skip to main content',
    'footer.tagline': '- The preferred maritime administration',
    'footer.about.title': 'About sdir.no',
    'footer.about.privacy': 'Privacy Policy',
    'footer.about.accessibility': 'Accessibility statement',
    'footer.social.title': 'Follow us',
    'footer.social.facebook': 'Visit us on Facebook',
    'footer.social.instagram': 'Visit us on Instagram',
    'footer.social.linkedin': 'Visit us on LinkedIn',
    'general.back': 'Back',
    'general.cancel': 'Cancel',
    'general.yes': 'Yes',
    'general.add': 'Add',
    'general.submit': 'Submit',
    'general.backtoapplications': 'Back to applications',
    'general.next': 'Next',
    'general.upload': 'Upload',
    'general.remove': 'Remove',
    'general.delete': 'Delete',
    'general.downloadpdf': 'Download as PDF',
    'general.clearfilter': 'Clear filter',
    'general.form.error': 'Required field',
    'general.form.name': 'Name',
    'general.form.gender': 'Gender',
    'general.form.firstname': 'First name',
    'general.form.lastname': 'Last name',
    'general.form.dateOfBirth': 'Date of birth',
    'general.form.email': 'Email',
    'general.form.error.dNumber': 'D number can only contain numbers.',
    'general.form.error.datemustbefuture': 'Please select a date later than today',
    'general.form.error.emptyfile': 'The file is empty. Please upload a valid file.',
    'general.form.error.mandatorylastname': 'Both first and last names are required.',
    'general.form.error.email': 'Not a valid email format',
    'dashboard.title': 'Ongoing applications',
    'dashboard.ingress':
      'On this page, you can apply for an Endorsement for seafarers and view the status of your ongoing applications.',
    'code.title': 'Register by code',
    'code.ingress':
      'If you have been invited to apply for endorsements and got a one time code, you should enter it here.',
    'usermanagement.title': 'User management',
    'usermanagement.table.note': 'Internal note',
    'usermanagement.table.status': 'Invitation status',
    'usermanagement.table.status.Accepted': 'Accepted',
    'usermanagement.table.status.Active': 'Awaiting',
    'usermanagement.table.status.Expired': 'Expired',
    'usermanagement.button.add': 'Add firm',
    'usermanagement.button.renew': 'Renew',
    'usermanagement.empty.title': 'No firms yet',
    'usermanagement.empty.description':
      'You have not invited any firms yet. To get started, add a new firm by clicking the button below.',
    'application.filter.status.New': 'New applications',
    'application.filter.status.Approved': 'Approved',
    'application.filter.status.Rejected': 'Rejected',
    'application.filter.status.ReadyForPayment': 'Ready for payment',
    'application.filter.status.Processing': 'Processing',
    'application.filter.status.AwaitingClarification': 'Awaiting clarification',
    'application.noaccess.title': 'No access yet',
    'application.noaccess.description':
      'You are not representing any shipping company yet. To get started, you need an activation code. Click the button to enter the code and gain access.',
    'application.empty.title': 'No applications yet',
    'application.empty.description':
      'You have not created an application yet. To get started, create a new application by clicking the button below.',
    'application.cra.heading': 'CRA',
    'application.dispensation.heading': 'Dispensation',
    'application.confirmdelete.title': 'Delete application',
    'application.confirmdelete.description': 'Are you sure you want to delete the application?',
    'application.rejection.link': 'Reason',
    'application.rejection.title': 'Reason for rejection',
    'application.receipt.link': 'Receipt',
    'application.endorsement.minrequirements':
      'This certificate is issued in accordance with the International Convention on Standards of Training, Certification, and Watchkeeping for Seafarers, 1978, as amended.',
    'application.endorsement.limitation': 'In accordance with national certification',
    'application.new.title': 'Apply for Endorsement',
    'application.new.ingress':
      'To apply for an Endorsement on behalf of a seafarer, fill out the form and attach the required documentation. We require the seafarer’s personal email address, to send login details for accessing and sharing their certificates.',
    'application.code.button': 'Enter code',
    'application.new.button': 'New application',
    'application.steps.applicant': 'Applicant',
    'application.steps.sailor': 'Seafarer',
    'application.steps.certificate': 'National certificate',
    'application.steps.requirements': 'Requirement',
    'application.steps.cra': 'CRA',
    'application.steps.summary': 'Summary',
    'application.steps.payment': 'Payment',
    'application.steps.payment.submit': 'Pay application',
    'application.table.header.createdAt': 'Created at',
    'application.table.header.name': 'Name of seafarer',
    'application.table.header.status': 'Status',
    'application.table.header.payment': 'Payment',
    'application.table.header.nationality': 'Nationality',
    'application.table.header.contactEmail': 'Applicant',
    'application.table.header.endorsement': 'Endorsement',
    'application.table.header.onBehalfOf': 'On behalf of',
    'application.table.count': 'Count',
    'application.table.showdetails': 'View application details',
    'application.table.hidedetails': 'Hide application details',
    'application.applicant.title': 'Your information',
    'application.applicant.onbehalf': 'On behalf of',
    'application.applicant.email': 'Company email',
    'application.sailor.title': 'Information about the seafarer',
    'application.sailor.description':
      'You can find the sailor by previous endorsements. Enter the information manually if the seafarer is new to Sjøfartsdirektoratet.',
    'application.sailor.previouslyregistered':
      'Does the sailor have a certificate issued by Sjøfartsdirektoratet',
    'application.sailor.yes': 'Yes, enter certificate number',
    'application.sailor.no': 'No, register manually',
    'application.sailor.name': 'Name of seafarer',
    'application.sailor.photo': 'Sailor photo',
    'application.sailor.citizenship': 'Citizenship',
    'application.sailor.dNumber': 'Norwegian d number (optional)',
    'application.sailor.email': 'Personal/private email',
    'application.sailor.emailinfo':
      'We require the seafarer’s personal email address (not the company email). Login details will be sent to the seafarer so they can access their endorsements.',
    'application.certificate.title': 'Seafarers National Certificate',
    'application.certificate.requestedCertificate': 'Requested certificate',
    'application.certificate.certificate': 'National certificate',
    'application.certificate.certificateNumber': 'Certificate number',
    'application.certificate.expiryDate': 'Date of expiry',
    'application.certificate.issuedBy': 'Issued by',
    'application.certificate.nationalcertificate': 'Copy of national certificate',
    'application.certificate.add': 'Add certificate',
    'application.certificate.remove': 'Remove certificate',
    'application.certificate.radioinfo':
      'Applications for GOC/ROC and other endorsements must be submitted as separate applications.',
    'application.requirements.title': 'Requirements for issuance of the selected endorsement',
    'application.requirements.declaration.title': 'Declaration of competence',
    'application.requirements.declaration.description':
      'The applicant has the necessary knowledge of Norwegian maritime legislation and has satisfactory command of the English language,  as required by regulation  I/10 of the STCW Convention, cf. Regulations of 22 December 2011 No. 1523 section 85  subparagraph (1) (b).',
    'application.requirements.declaration.checkbox':
      'I hereby declare compliance with the applicable competence requirements.',
    'application.requirements.grossTonnage.title': 'Dispensation for Master – Gross Tonnage',
    'application.requirements.grossTonnage.description': ' ',
    'application.requirements.grossTonnage.option1':
      'To be used exclusively for vessels below 250 GT (small vessels)',
    'application.requirements.grossTonnage.option2':
      'The vessel has a gross tonnage of more than 250 GT',
    'application.requirements.dispensation.title': 'Dispensation',
    'application.requirements.dispensation.description':
      'An endorsement issued to seafarers who are not EEA citizens does not entitle the holder to serve as master on ships of 250 gross tonnage or more. However, the Norwegian Maritime Authority may permit such service on ships which are registered in the Norwegian International Ship Register. The Norwegian Maritime Authority may take emergency preparedness into consideration when assessing whether permission shall be given, in accordance with Section 87 (3) of the Regulations of 22 December 2011 No. 1523 on qualifications and certificates for seafarers.',
    'application.requirements.dispensation.checkbox':
      'I confirm that I wish to apply for this permission in accordance with the conditions stated above',
    'application.requirements.course.title': 'Course',
    'application.requirements.course.description':
      'To serve as a master on board a Norwegian ship, completion of the Course in Norwegian Maritime Legislation (NIS course) at an approved course center is mandatory.',
    'application.requirements.error.dispensation':
      'When vessel tonnage is more than 250, you need dispensation.',
    'application.requirements.error.nationality':
      'Your nationality prevents you from getting dispensation.',
    'application.cra.title': 'Confirmed receipt of application (CRA)',
    'application.cra.description':
      'Below is an indication of whether a temporary Certificate of Recognition (CRA) can be issued automatically.',
    'application.cra.automatic': 'Do you want CRA issued automatically?',
    'application.summary.title': 'Summary',
    'application.summary.crainfo.title': 'Important Information Regarding CRA Issuance:',
    'application.summary.crainfo.part1':
      'The Certificate of Receipt of Application (CRA) will only be issued once the payment has been registered by the Norwegian Maritime Authority.',
    'application.summary.crainfo.part2':
      'If you need the <b>CRA urgently</b>, we strongly recommend paying by credit card. Payment by invoice and bank transfer to the organisation takes up to one week before it is registered and the CRA can be issued.',
    'application.summary.crainfo.part3':
      'Once the payment is registered, the CRA will be available for download from your application page.',
    'application.address.title': 'Send to address',
    'application.address.company': 'Company',
    'application.address.contactEmail': 'Contact email',
    'application.address.address': 'Address',
    'application.address.address2': 'Address 2',
    'application.address.zip': 'Zip code',
    'application.address.city': 'City',
    'application.address.country': 'Country',
    'application.payment.title': 'Payment',
    'application.payment.nocharges': 'Could not find any charges',
    'application.payment.alreadypaid.title': 'Payment has already been made',
    'application.payment.alreadypaid.description': 'The application is now awaiting processing.',
    'application.payment.couldnotstart':
      'Could not start the payment process, please try again later.',
    'application.payment.complete': 'Go to summary',
    'application.payment.failed': 'Could not complete payment',
    'application.clarify.title': 'Awaiting clarification',
    'application.clarify.comment': 'Comment',
    'application.clarify.niscourse': 'NIS-course',
    'application.clarify.nationalcertificate': 'National certificate',
    'application.clarify.upload.niscourse': 'Upload NIS-course',
    'application.clarify.upload.niscourse.desc': 'Upload documentation for NIS-course',
    'application.clarify.upload.nationalcertificate': 'Upload national certificate',
    'application.clarify.upload.nationalcertificate.desc': 'Upload documentation for ',
    'imagecropper.cancel': 'Cancel',
    'imagecropper.upload': 'Upload new image',
    'imagecropper.Photo': 'Photo',
    'imagecropper.zoom': 'Zoom',
    'imagecropper.rotation': 'Rotation',
  },
};
/* eslint-enable max-len */
